import { render } from "./view_admin.html?vue&type=template&id=4207670b&external"
import script from "./view_admin.js?vue&type=script&lang=js&external"
export * from "./view_admin.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__